export const defaultFAconfig = {
    barnesHutOptimize: false,
    iterationsPerRender: 10,
    edgeWeightInfluence: 1,
    maxNodeSize: 9999,
    maxEdgeSize: 20,
    slowDown: 2,
    scalingRatio: 10000,
    gravity: 0,
}

export const defaultRendererConfig = {
	labelThreshold: 7
}

export function randomize(nodes) {
    nodes.forEach((node) => {
        node.x = Math.random()
        node.y = Math.random()
    })
}

export function distance(a, b) {
    return Math.sqrt((a.x - b.x) ** 2 + (a.y - b.y) ** 2)
}

export function hasChanged(oldNodes, newNodesFinder, threshold=53) {
    // Tell wether the graph has changed or not
    // oldNodes must be a deep copy of graph.nodes() ouput and newNodesFinder must be graph.nodes
    return Math.max(
        ...oldNodes.map(oldNode => distance(oldNode, newNodesFinder(oldNode.id)))
    ) > threshold
}




// WEBPACK FOOTER //
// ./src/graph-utils.js